module.exports = __webpack_public_path__ + "static/media/dp.f6ef03c5.jpeg";